export default require('../../client/marriageintention').default;
